import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66584bbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-12 flex h-[520px] w-[520px] flex-col items-center justify-center rounded-[20px] bg-white px-[50px]" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-[35px] text-[28px] font-bold leading-[136%]" }, "LOGIN", -1))
const _hoisted_4 = { class: "relative mb-4 h-12 w-full" }
const _hoisted_5 = { class: "absolute right-[18px] top-[50%] flex translate-y-[-50%] items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1 text-[12px] font-normal leading-[136%] tracking-[-0.02em] text-[#FF003E]" }, " 올바른 아이디가 아니에요! ", -1))
const _hoisted_8 = { class: "relative mb-8 h-12 w-full" }
const _hoisted_9 = { class: "absolute right-[18px] top-[50%] flex translate-y-[-50%] items-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1 text-[12px] font-normal leading-[136%] tracking-[-0.02em] text-[#FF003E]" }, " 틀린 비밀번호예요! ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex h-full w-full items-center justify-center bg-[#F5F5F5]",
    onKeypress: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleKeyPress && _ctx.handleKeyPress(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: require('@assets/logo/amy_logo.png'),
        alt: "amy logo",
        class: "mb-[33px] h-[52px]"
      }, null, 8, _hoisted_2),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.userId) = $event)),
          type: "email",
          placeholder: "휴멜로 계정정보를 입력해주세요.",
          class: _normalizeClass(["relative h-full w-full rounded-[10px] border-[1px] border-solid px-[18px] text-[14px] font-normal leading-[136%] tracking-[-0.015em]", [_ctx.validate.userId ? 'border-[rgba(131,144,165,0.5)]' : 'border-[#FF003E]']]),
          onInput: _cache[1] || (_cache[1] = () => (_ctx.validate.userId = true))
        }, null, 34), [
          [_vModelText, _ctx.formData.userId]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: require('@assets/icons/Error.svg')
          }, null, 8, _hoisted_6),
          _hoisted_7
        ], 512), [
          [_vShow, !_ctx.validate.userId]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event)),
          type: "password",
          placeholder: "비밀번호를 입력해주세요.",
          class: _normalizeClass(["relative h-full w-full rounded-[10px] border-[1px] border-solid px-[18px] text-[14px] font-normal leading-[136%] tracking-[-0.015em]", [_ctx.validate.password ? 'border-[rgba(131,144,165,0.5)]' : 'border-[#FF003E]']]),
          onInput: _cache[3] || (_cache[3] = () => (_ctx.validate.password = true))
        }, null, 34), [
          [_vModelText, _ctx.formData.password]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: require('@assets/icons/Error.svg')
          }, null, 8, _hoisted_10),
          _hoisted_11
        ], 512), [
          [_vShow, !_ctx.validate.password]
        ])
      ]),
      _createElementVNode("button", {
        type: "submit",
        class: _normalizeClass(["mb-[5px] h-12 w-full rounded-[10px] text-base font-bold leading-[21px] text-white transition-all", [
          _ctx.formData.userId.length > 0 && _ctx.formData.password.length > 0
            ? 'bg-[#4535D8]'
            : 'pointer-events-none bg-[rgba(131,144,165,0.6)]',
        ]]),
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
      }, " 로그인 ", 2)
    ])
  ], 32))
}